import { Col, Row } from 'react-bootstrap';

import CmsTransformer from '~/components/cms/CmsTransformer';
import { CmsTwoColumnsProps } from '~/types/Cms';

const CmsTwoColumns = ({ data }: CmsTwoColumnsProps) => {
  let firstColumnWidth = 6;
  let secondColumnWidth = 6;
  const marginAutoClass = data.marginAuto ? 'm-auto' : '';
  const reverseMobileClass = data.reverseMobile ? 'flex-column-reverse' : 'flex-column';

  switch (data.firstColumnWidth) {
    case '1/5':
      firstColumnWidth = 2;
      secondColumnWidth = 10;
      break;
    case '1/4':
      firstColumnWidth = 3;
      secondColumnWidth = 9;
      break;
    case '1/3':
      firstColumnWidth = 4;
      secondColumnWidth = 8;
      break;
    case '2/5':
      firstColumnWidth = 5;
      secondColumnWidth = 7;
      break;
    case '1/2':
      firstColumnWidth = 6;
      secondColumnWidth = 6;
      break;
    case '3/5':
      firstColumnWidth = 7;
      secondColumnWidth = 5;
      break;
    case '2/3':
      firstColumnWidth = 8;
      secondColumnWidth = 4;
      break;
    case '3/4':
      firstColumnWidth = 9;
      secondColumnWidth = 3;
      break;
    case '4/5':
      firstColumnWidth = 10;
      secondColumnWidth = 2;
      break;
    default:
      firstColumnWidth = 6;
      secondColumnWidth = 6;
      break;
  }

  return (
    <Row className={`${reverseMobileClass} flex-lg-row row-gap-3`}>
      <Col xs={12} lg={firstColumnWidth} className={marginAutoClass}>
        {data.firstColumn.map((item, index) => (
          <CmsTransformer key={index} item={item} />
        ))}
      </Col>
      <Col xs={12} lg={secondColumnWidth} className={marginAutoClass}>
        {data.secondColumn.map((item, index) => (
          <CmsTransformer key={index} item={item} />
        ))}
      </Col>
    </Row>
  );
};

export default CmsTwoColumns;
